var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.6002,
    r: 15,
    fill: "#D42216"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.60016C13.6744 9.60163 12.4035 10.0988 11.4662 10.9826C10.5289 11.8664 10.0016 13.0646 10 14.3144C9.99842 15.3358 10.3523 16.3295 11.0073 17.143C11.0073 17.143 11.1436 17.3123 11.1659 17.3367L15 21.6002L18.8359 17.3346C18.8559 17.3119 18.9927 17.143 18.9927 17.143L18.9932 17.1417C19.6479 16.3286 20.0015 15.3354 20 14.3144C19.9984 13.0646 19.4711 11.8664 18.5338 10.9826C17.5965 10.0988 16.3256 9.60163 15 9.60016ZM15 16.0287C14.6404 16.0287 14.2889 15.9282 13.9899 15.7398C13.6909 15.5515 13.4578 15.2837 13.3202 14.9705C13.1826 14.6572 13.1466 14.3125 13.2168 13.98C13.2869 13.6475 13.4601 13.342 13.7144 13.1023C13.9686 12.8625 14.2926 12.6992 14.6453 12.6331C14.998 12.567 15.3636 12.6009 15.6958 12.7307C16.028 12.8604 16.312 13.0801 16.5118 13.362C16.7115 13.644 16.8182 13.9754 16.8182 14.3144C16.8176 14.7689 16.6258 15.2046 16.285 15.526C15.9441 15.8474 15.482 16.0282 15 16.0287Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLocation);
export default __webpack_public_path__ + "static/media/infoLocation.a2f5493494b1e82b7dee3cf205542e56.svg";
export { ForwardRef as ReactComponent };